import { onMounted, ref } from "vue"
import useApp from "@/composables/useApp"
import router from "@/router/index"
import axios from "@/axios"
const useRegister = () => {
    const { validEmail, ToastMsgSuccess, ToastMsgWarning, ToastMsgError,getQueryParam, showPassword } = useApp()
    let data = ref({
        errors: [],
        user: {
            name: "",
            email: "",
            password: "",
            token: ""
        }
    })

    const register = () => {

        const axiosHeader = {
            headers: {
                token: data.value.user.token
            }
        }

        axios
            .post("/register", data.value.user, axiosHeader)
            .then(res => {
                //success! - Usuario creado.
                if (res.data.status == "success") {
                    ToastMsgSuccess("Registrado Con exito! Ahora Puedes Inciar Sesion", "user", 5000)
                    router.push('/login');
                    return;
                }else if (res.data.status == "error") {
                    ToastMsgError(res.data.message , "user", 5000)
                    router.push('/login');
                    return;
                }

            })
            .catch(e => {
                if (e.response == undefined) {
                    ToastMsgError("Api Server Not Found !", "server", 5000)
                    return
                } else if (e.response.status == 401) {
                    ToastMsgWarning(" No autorizado !", "frown", 5000)
                    router.push("/login")
                    return
                } else if (e.response.data.error.errors.email.kind == "unique") {
                    ToastMsgWarning("El Usuario ya ha sido registrado !", "frown", 5000)
                    return;
                }
                
                ToastMsgError("Error !", "server", 5000)

            });

    }

    const check_form = () => {
        data.value.errors = [];

        if (!data.value.user.name || data.value.user.name.length < 4) {
            data.value.errors.push("- Nombre Minimo de 4 caracteres !")
        };

        if (!data.value.user.email) {
            data.value.errors.push('- Email es requerido!');
        } else if (!validEmail(data.value.user.email)) {
            data.value.errors.push('- El campo email no es valido!');
        };

        if (!data.value.user.password) {
            data.value.errors.push('- La contraseña es requerida !');
        } else if (data.value.user.password.length < 6) {
            data.value.errors.push("- Contraseña Minimo 6 Caracteres!")

        };

        if (data.value.errors == 0) {
            register()
        }

        data.value.errors.map((msg) => {
            ToastMsgWarning(msg, "user", 5000)
        })


    }

    onMounted(() => {
        if (window.location.search != "") {
            data.value.user.email = decodeURIComponent(getQueryParam("email"));
            data.value.user.token = decodeURIComponent(getQueryParam("token"));
        }
    })






    return {
        data,
        check_form,
        showPassword
    }
}


export default useRegister